export const generateLoginUrl = (codeChallenge: string): string => {
  const state = 'capacitor-login-' + Math.random().toString(36).substring(2);
  const baseUrl = import.meta.env.VITE_KEYCLOAK_URL.replace(/\/$/, '');
  const loginUrl =
    `${baseUrl}/realms/${import.meta.env.VITE_KEYCLOAK_REALM}/protocol/openid-connect/auth?` +
    `client_id=${encodeURIComponent(import.meta.env.VITE_KEYCLOAK_CLIENT_ID)}&` +
    `redirect_uri=${encodeURIComponent('capacitor://localhost')}&` +
    `state=${encodeURIComponent(state)}&` +
    `response_type=code&` +
    `scope=openid&` +
    `code_challenge=${encodeURIComponent(codeChallenge)}&` +
    `code_challenge_method=S256`;

  return loginUrl;
};
